import Vue from 'vue'
import Vuex from 'vuex'

import User from './user_store'
import Projects from './projects_store'
import Kvs from './kvs_store'
import Fs from './fs_store'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    User,
    Projects,
    Kvs,
    Fs
  }
})

export default store

const initialStateCopy = JSON.parse(JSON.stringify(store.state))

export function resetState () {
  console.log('yeet')
  store.replaceState(JSON.parse(JSON.stringify(initialStateCopy)))
}
